export const URL_WEBSERVICE = 'https://minipacs.familyhospital.vn/service';
